/*
 * @Author: your name
 * @Date: 2021-06-07 20:40:40
 * @LastEditTime: 2021-06-17 15:15:21
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /burgeon-project-logic/service/modules/organizationCenter.js
 */
// 组织中心
export default {
  usersSave: (params) =>
    $network.post('/p/cs/md/v1/users/save', params), //修改密码
  /**
   * 导入
   */
  importPopApiArr: () => {
    const arr = [
      {
        tableName: 'CP_C_RSTORE',
        importUrl: '/api/cs/md/batch/update', // 导入接口
        columnUrl: '/api/cs/md/queryAddColumn', // 获取表头接口
        downloadUrl: '/api/cs/md/downloadRealProTemp', // 下载模板接口
      }, // 门店档案-导入（可选择表头下载对应模板）

    ];
    return arr;
  },

};
